import cx from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './OMAccordion.scss';

export default class OMAccordion extends Component {
  state = {
    accordionOpen: this.props.accordionOpen,
    height: 0
  };

  componentDidMount() {
    setTimeout(() => {
      if (this.props.accordionOpen) {
        const contentEl = this.accordionSectionContent;
        let marginTop = contentEl && contentEl.firstChild && window.getComputedStyle(contentEl.firstChild).marginTop;
        marginTop = parseInt(marginTop, 10) || 0;
        // Any suggestion how to improve it?
        this.setState(
          { height: ((contentEl && contentEl.scrollHeight) || 0) + marginTop },
          () => this.props.afterInitialOpen && this.props.afterInitialOpen()
        );
      }
    }, 300);
  }
  componentWillReceiveProps({ accordionOpen }) {
    if (this.props.accordionOpen !== accordionOpen) {
      this.setState({ accordionOpen });
    }
  }

  onChange = () => {
    const accordionOpen = !this.state.accordionOpen;
    const contentEl = this.accordionSectionContent;
    let height;
    if (accordionOpen) {
      let marginTop = contentEl && contentEl.firstChild && window.getComputedStyle(contentEl.firstChild).marginTop;
      marginTop = parseInt(marginTop, 10) || 0;
      height = ((contentEl && contentEl.scrollHeight) || 0) + marginTop;
      if (this.props.onOpen) { this.props.onOpen(); }
    } else if (this.props.onClose) {
      this.props.onClose();
    }

    height = height || this.state.height;

    this.setState({
      accordionOpen,
      height
    });
  };

  render() {
    const style = (this.state.accordionOpen && this.state.height) ? { height: `${this.state.height}px` } : {};

    return (
      <div className={cx(styles.accordion, this.props.className)}>
        <div className={styles.accordionSection}>
          <div onClick={this.onChange} className={cx(styles.accordionHeader, 'accordion-header')}>
            <span className={cx(styles.accordionSectionTitle, 'accordion-title')}>{this.props.titleValue}</span>
            <span
              className={cx('icon', {
                'icon-arrow-up': this.state.accordionOpen,
                'icon-arrow-down': !this.state.accordionOpen
              })}
            />
          </div>
          <div
            className={cx(styles.accordionSectionContent, 'accordion-content', { [styles.open]: this.state.accordionOpen })}
            style={style}
            ref={(ref) => { this.accordionSectionContent = ref; }}
          >
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

OMAccordion.propTypes = {
  titleValue: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object]),
  accordionOpen: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  afterInitialOpen: PropTypes.func
};

OMAccordion.defaultProps = {
  accordionOpen: false
};
